import { render, staticRenderFns } from "./SetCategoryChallengeInputPopup.vue?vue&type=template&id=405fabe6&scoped=true"
import script from "./SetCategoryChallengeInputPopup.vue?vue&type=script&lang=js"
export * from "./SetCategoryChallengeInputPopup.vue?vue&type=script&lang=js"
import style0 from "./SetCategoryChallengeInputPopup.vue?vue&type=style&index=0&id=405fabe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405fabe6",
  null
  
)

export default component.exports